import { PartnerApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useCreate() {
  const queryClient = useQueryClient();

  return useAuthMutation(PartnerApi.patch, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).all,
      });
    },
  });
}

export default useCreate;
